import { DateService } from '@application/time/date.service';
import { v4 } from 'uuid';

export type KnownApplicationNotificationTypes = 'localPush' | 'banner';

export abstract class ApplicationNotification<T extends string = KnownApplicationNotificationTypes> {
	public readonly guid: string;
	public readonly timestamp: VisibaDate;
	public abstract readonly event: T;

	constructor(sid?: string) {
		this.timestamp = DateService.newDate();
		this.guid = sid ?? v4();
	}
}

export interface ApplicationNotificationSpecificationBase<_T extends ApplicationNotification> {
	guid?: string;
}
